//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.KPredaniUzluListPage.ts              </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class KPredaniUzluListPage extends GContentBase<PodDokSpisListBasePage>
    {
        model: Wfl.Interface.GRedistribuceKPredaniFilterDto;

        onContentReady() {
            var that = this;
            PodDokSpisListBasePage.InitList(this);
            this.topActions.push(Wfl.ListAC.WflListBaseAC.CreateActionDetailDokSpis(this));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionPredat(this, true));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionPridelit(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionVratitPoste(this, true));
            this.specialActions.push(Wfl.ListAC.WflListBaseAC.CreateActionStornovat(this));
            this.specialActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionZrusitPrideleni(this, true));
            this.specialActions.push(PodDokSpisListBasePage.CreateActionOpravaElPodani(this, true));
            this.printActions.push(Wfl.ListAC.DokSpisListBaseAC.CreateActionTiskPredavacihoProtokoluDokSpis(this, Wfl.Interface.TypAkce.predani, false));

            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: "all",
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_dsred" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"
                })

            Wfl.ListAC.DokSpisListBaseAC.CreateGridDokSpis(this);
            this.findFields().gfield("model", "apply", this.model);
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)
        }

        CreateFilterForms() {
            let that = this;
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }); //RC 26285623 : Filtr balíků
            filterForm.addSection("");
            filterForm.addRow({ label: "" }).addField("gradio", {
                name: "TypSubjektu", itemClass: "",
                initialValue: this.model.TypSubjektu,
                radios: [
                    { value: Gin.Interface.IxsType.IxsSu, label: 'jres:23900149' }, //RC 23900149 : na uzel
                    { value: Gin.Interface.IxsType.IxsFun, label: 'jres:23900150' }, //RC 23900150 : osobě
                ],
                change: function (event, input) {
                    //if (input.value) {
                    //    if (that.defaultForm) {
                    //        that.defaultForm.findFields(fieldNames.referent).gfield("option", "disabled", input.value != 1);
                    //        that.defaultForm.findFields(fieldNames.extSubject).gfield("option", "disabled", input.value == 1);
                    //    }
                    //}
                }
            })

            filterForm.addRow({ label: "jres:23900217" }).addField("gselectbox", Gin.Prefabs.Field.SpisovyUzel(Gin.Prefabs.Field.MergeOptions({ //RC 23900217 : Přebírající
                name: "IxsSu", disabled: true,  model: "model.IxsSu = value.{1}".format("ixs_su", Gordic.Data.Readers.GinspodDtoNames.ixs_su)
            }), false))

            filterForm.addPrefab(Gordic.Gin.Prefabs.GSuFunRef(
                {
                    name: "Prebirajici",
                    model: "model.Prebirajici.ixs_su=value.ixs_su;model.Prebirajici.ixs_fun=value.ixs_fun",
                    serverFilters: {
                        aktivita: [100], ixs_su: this.model.Prebirajici.ixs_su
                    },
                    change: function (ev, data) {
                        Gordic.Wfl.ListAC.WflListBaseAC.SetIxsFunOperation(that, data.value);
                    }
                },
                // 26.03.2020 - TFeik
                // Doplněn příznak zda se funkce používá v redistribuci / předání.
                undefined,
                {
                    modPredani: true
                }));

            filterForm.addRow()
                .addField("gcheck", { name: "Vlastni", label: "jres:23900106" })//RC 23900106 : Vlastní
                .addField("gcheck", { name: "PredatNaOsobu", label: "jres:23900143", change: (ev, obj) => { this.PredatNaOsobu = obj.value;  } }); //RC 23900143 : Předat na osobu

            return [filterForm];
        }

        LoadData(filtr?: Wfl.Interface.GRedistribuceKPredaniFilterDto)
        {
            Gin.Globals.ShowWaitLoadData(this);
            this.model = $.extend({}, this.model, filtr);
            if (this.model) {
                const that = this;
                Gin.Globals.ShowWaitLoadData(this);
                //nacteni dat do gridu
                this.call<Wfl.Interface.DokSpisListDto[]>("LoadData", { "model": this.model })
                    .done(function (data) {
                        var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                        that.mainGrid.ggrid("setData", view);
                        that.IxsSuOperation = that.model.IxsSu;
                        that.IxsFunOperation = that.model.Prebirajici.ixs_fun;
                    })
                    .always(function () { Gordic.Wfl.ListAC.DokSpisListBaseAC.AfterLoadData(that); });
            }
        }

        ReloadData() {
            this.LoadData(this.model);
        }
    }
};
